import React from 'react';
import { Trans } from 'react-i18next';
const Underline: React.FC<{ children?: React.ReactNode }> = ({ children }: { children?: React.ReactNode }) => (
  <span style={{ textDecoration: 'underline' }}>{children}</span>
);

type HTMLParsedTextPropsType = { html: string };
export const HTMLParsedText = ({ html }: HTMLParsedTextPropsType) => (
  <Trans defaults={html} components={{ u: <Underline /> }} />
);
